<p
  class="feature-tag {{ tagType }}"
  [class.small]="tagSize === 'small'"
  [class.medium]="tagSize === 'medium'"
  [class.large]="tagSize === 'large'"
  [class.absolute]="isAbsoluteElement"
  [class.blue-gradient]="blueGradient"
  [style.transform]="'translate(' + translateTagX + '%,' + translateTagY + '%)'">
  {{ tagText }}

  @if (tagType === 'ai') {
    <svg width="7" height="8" class="icon">
      <use xlink:href="#sparkles"></use>
    </svg>
  }
</p>
